import * as XLSX from 'xlsx';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

const buildDetailedReportFileName = (baseName, payPeriod = null, companyId = null) => {
  const companyPart = companyId ? `-Company-${companyId}` : '';
  return payPeriod
    ? `${baseName}${companyPart}-${payPeriod}.xlsx`
    : `${baseName}${companyPart}.xlsx`;
};

export const exportHalperinTransfersFeesFile = (jsonData, showToast, payPeriod = null, companyId = null) => {
  const keyMapping = {
    employeeName: 'שם עובד',
    govId: 'תעודת זהות',
    totalAmount: 'סה"כ מקדמה',
    totalTransferFee: 'סה"כ עמלה',
    employeeInternalId: 'מספר עובד',
  };

  // Transform JSON data to use Hebrew keys
  const transformedData = jsonData.map((item) => {
    return Object.keys(item).reduce((newItem, key) => {
      if (keyMapping[key]) {
        // Check if the key exists in the keyMapping
        newItem[keyMapping[key]] = item[key];
      }
      return newItem;
    }, {});
  });

  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // Convert JSON to worksheet
  const worksheet = XLSX.utils.json_to_sheet(transformedData);

  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'TransfersListWithFee');

  // Define filename for the Excel file following Payro pattern
  const fileName = buildDetailedReportFileName('Payro-DetailedReport', payPeriod, companyId);

  // Write and download the file
  XLSX.writeFile(workbook, fileName);
  showToast({
    position: 'top',
    title: 'הורדת המסמך הצליחה',
    status: 'success',
    duration: 5000,
    isClosable: true,
  });
};

export const exportXtrasTransfersFeesFile = (jsonData, showToast, payPeriod = null, companyId = null) => {
  const keyMapping = {
    employeeName: 'שם עובד',
    govId: 'תעודת זהות',
    totalAmount: 'סה"כ מקדמה',
    totalTransferFee: 'סה"כ עמלה',
  };

  // Same as Halperin format, without employee number column.
  const transformedData = jsonData.map((item) => {
    return Object.keys(item).reduce((newItem, key) => {
      if (keyMapping[key]) {
        newItem[keyMapping[key]] = item[key];
      }
      return newItem;
    }, {});
  });

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(transformedData);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'TransfersListWithFee');

  const fileName = buildDetailedReportFileName('Payro-DetailedReport', payPeriod, companyId);

  XLSX.writeFile(workbook, fileName);
  showToast({
    position: 'top',
    title: 'הורדת המסמך הצליחה',
    status: 'success',
    duration: 5000,
    isClosable: true,
  });
};

export const exportElectraTransfersFeesFile = (jsonData, showToast) => {
  const keyMapping = {
    employeeName: 'שם עובד',
    totalAmount: 'סה"כ מקדמה',
    totalTransferFee: 'סה"כ עמלה',
    employeeInternalId: 'מספר עובד',
  };

  // Transform JSON data to use Hebrew keys
  const transformedData = jsonData.map((item) => {
    return Object.keys(item).reduce((newItem, key) => {
      if (keyMapping[key]) {
        // Check if the key exists in the keyMapping
        newItem[keyMapping[key]] = item[key];
      }
      return newItem;
    }, {});
  });

  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // Convert JSON to worksheet
  const worksheet = XLSX.utils.json_to_sheet(transformedData);

  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'TransfersListWithFee');

  // Define filename for the Excel file
  const fileName = 'Payroll-Detailed.xlsx';

  // Write and download the file
  XLSX.writeFile(workbook, fileName);
  showToast({
    position: 'top',
    title: 'הורדת המסמך הצליחה',
    status: 'success',
    duration: 5000,
    isClosable: true,
  });
};

export const exportFormReportPdfZipFile = (jsonData) => {
  const zip = new JSZip();
  const pdfs = jsonData.map((item) => {
    return {
      name: `${item.userFullName}_${item.formId}.pdf`,
      content: item.signedContent,
    };
  });

  pdfs.forEach((pdf) => {
    zip.file(pdf.name, pdf.content, { base64: true });
  });

  zip.generateAsync({ type: 'blob' }).then((content) => {
    saveAs(content, 'FormReport.zip');
  });
};

export const exportFormsReportFile = (data) => {
  try {
    // Convert JSON data to the desired format with translated column names
    const finalArray = data.map((item) => ({
      'שם עובד': item.userFullName,
      'מספר טופס': item.formId,
      'תאריך מדויק': item.exactDate,
      'מזהה מכשיר': item.userAgent,
      'כתובת IP': item.ip,
    }));

    // Create worksheet and workbook
    const newWorksheet = XLSX.utils.json_to_sheet(finalArray);
    const newWorkbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, 'Sheet1');

    // Fix headers
    XLSX.utils.sheet_add_aoa(
      newWorksheet,
      [['שם עובד', 'מספר טופס', 'תאריך מדויק', 'מזהה מכשיר', 'כתובת IP']],
      { origin: 'A1' },
    );

    // Write the workbook to a file
    XLSX.writeFile(newWorkbook, 'FormReport.xlsx');
  } catch (e) {
    console.error('Error exporting Excel file:', e);
  }
};

export const exportHomeCenterTransfersFeesFile = (jsonData, showToast, payPeriod = null, companyId = null) => {
  const keyMapping = {
    employeeInternalId: 'מספר עובד',
    govId: 'תעודת זהות',
    employeeFirstName: 'שם עובד',
    employeeLastName: 'שם משפחה',
    totalAmount: 'גובה מקדמה לניכוי',
    totalTransferFee: 'סה"כ עמלה לניכוי',
    branch: 'סניף',
  };

  // Transform JSON data to use Hebrew keys
  const transformedData = jsonData.map((item) => {
    return Object.keys(item).reduce((newItem, key) => {
      if (keyMapping[key]) {
        // Check if the key exists in the keyMapping
        newItem[keyMapping[key]] = item[key];
      }
      return newItem;
    }, {});
  });

  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // Convert JSON to worksheet
  const worksheet = XLSX.utils.json_to_sheet(transformedData);

  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'TransfersListWithFee');

  // Define filename for the Excel file following Payro pattern
  const fileName = buildDetailedReportFileName('Payro-DetailedReport', payPeriod, companyId);

  // Write and download the file
  XLSX.writeFile(workbook, fileName);
  showToast({
    position: 'top',
    title: 'הורדת המסמך הצליחה',
    status: 'success',
    duration: 5000,
    isClosable: true,
  });
};

export const exportPazDetailedReport = (jsonData, showToast) => {
  const keyMapping = {
    employeeName: 'שם עובד',
    employeeId: 'מספר עובד',
    requestDate: 'תאריך הבקשה',
    actualTransferDate: 'תאריך העברה בפועל',
    advance: 'מקדמה',
    commission: 'עמלה',
    totalDeduction: 'סכום לניכוי',
    bankReference: 'אסמכתא בנקאית',
  };

  // Transform JSON data to use Hebrew keys
  const transformedData = jsonData.map((item) => {
    return Object.keys(item).reduce((newItem, key) => {
      if (keyMapping[key]) {
        newItem[keyMapping[key]] = item[key];
      }
      return newItem;
    }, {});
  });

  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // Convert JSON to worksheet
  const worksheet = XLSX.utils.json_to_sheet(transformedData);

  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'PazDetailedReport');

  // Define filename for the Excel file
  const fileName = 'Paz-Detailed-Report.xlsx';

  // Write and download the file
  XLSX.writeFile(workbook, fileName);
  showToast({
    position: 'top',
    title: 'הורדת הדו"ח המפורט הצליחה',
    status: 'success',
    duration: 5000,
    isClosable: true,
  });
};

/**
 * Export "payro מפורט (אסמכתאות)" report with columns: שם עובד, תאריך הבקשה, מקדמה, עמלה, סכום לניכוי, אסמכתא בנקאית.
 * File name: Detailed-Report-{monthName}.xlsx
 */
export const exportDetailedReferencesReport = (jsonData, showToast, monthName = 'Report', companyId = null) => {
  const keyMapping = {
    employeeName: 'שם עובד',
    requestDate: 'תאריך הבקשה',
    advance: 'מקדמה',
    commission: 'עמלה',
    totalDeduction: 'סכום לניכוי',
    bankReference: 'אסמכתא בנקאית',
  };

  const transformedData = jsonData.map((item) => {
    return Object.keys(item).reduce((newItem, key) => {
      if (keyMapping[key]) {
        newItem[keyMapping[key]] = item[key];
      }
      return newItem;
    }, {});
  });

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(transformedData);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'DetailedReferences');

  const companyPart = companyId ? `-Company-${companyId}` : '';
  const fileName = `Detailed-Report${companyPart}-${monthName}.xlsx`;
  XLSX.writeFile(workbook, fileName);
  showToast({
    position: 'top',
    title: 'הורדת דוח מפורט אסמכתאות הצליחה',
    status: 'success',
    duration: 5000,
    isClosable: true,
  });
};

export const exportPazSummaryReport = (jsonData, showToast, customFileName = null) => {
  const keyMapping = {
    employeeName: 'שם עובד',
    employeeId: 'מספר עובד',
    totalAdvance: 'מקדמה',
    totalCommission: 'עמלה',
    totalDeduction: 'סכום לניכוי',
    transferCount: 'מספר העברות',
  };

  // Transform JSON data to use Hebrew keys
  const transformedData = jsonData.map((item) => {
    return Object.keys(item).reduce((newItem, key) => {
      if (keyMapping[key]) {
        newItem[keyMapping[key]] = item[key];
      }
      return newItem;
    }, {});
  });

  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // Convert JSON to worksheet
  const worksheet = XLSX.utils.json_to_sheet(transformedData);

  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'PazSummaryReport');

  // Define filename for the Excel file
  const fileName = customFileName || 'Paz-Summary-Report.xlsx';

  // Write and download the file
  XLSX.writeFile(workbook, fileName);
  showToast({
    position: 'top',
    title: 'הורדת הדו"ח המסכם הצליחה',
    status: 'success',
    duration: 5000,
    isClosable: true,
  });
};

export const exportMokedEmunTransfersFeesFile = (jsonData, showToast, payPeriod = null, companyId = null) => {
  const transformedData = jsonData.map((item) => {
    const mergedAmount = (item.totalAmount || 0) + (item.totalTransferFee || 0);

    return {
      מקדמה: mergedAmount,
      'שם עובד': item.employeeName || '',
      'ת"ז': item.govId || '',
      'מספר עובד': item.employeeInternalId || '',
    };
  });

  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // Convert JSON to worksheet
  const worksheet = XLSX.utils.json_to_sheet(transformedData);

  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'TransfersListWithFee');

  // Define filename for the Excel file following Payro pattern
  const fileName = buildDetailedReportFileName('Payro-DetailedReport', payPeriod, companyId);

  // Write and download the file
  XLSX.writeFile(workbook, fileName);
  showToast({
    position: 'top',
    title: 'הורדת המסמך הצליחה',
    status: 'success',
    duration: 5000,
    isClosable: true,
  });
};
